module.exports = __webpack_public_path__ + "img/sankaku_90_red.9fb8e102.png";